"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIMER_TYPE = void 0;
var TIMER_TYPE;
(function (TIMER_TYPE) {
    TIMER_TYPE["DAY_OF_WEEK"] = "day_of_week";
    TIMER_TYPE["RANGE"] = "range";
})(TIMER_TYPE = exports.TIMER_TYPE || (exports.TIMER_TYPE = {}));
